module.exports = "mat-slider{width:300px}.slider-content{height:200px;width:100%}#backBtn{float:right}\n"